// I kept the zIndexes as they were before
export const zIndex = {
  base: 1,
  searchModal: 4,
  inPageloading: 5,
  imagesAboveLoading: 6,
  plpArrows: 10,
  plpMenus: 15,
  checkoutMenus: 15,
  header: 20,
  afaCartDropSwitcher: 21,
  afaCartSummary: 22,
  backdrop: 23,
  subMenu: 100,
  shareAfaCartModal: 1010,
  rtrModal: 1011,
  afaPdpModal: 20000,
}
